import { ReactNode, createContext, useContext } from "react";
import { useFilterContract } from "./filter-contract.hook";

const FilterContractContext = createContext(
  {} as ReturnType<typeof useFilterContract>
);
export function useFilterContractContext() {
  return useContext(FilterContractContext);
}

interface FilterContractProviderProps {
  children: ReactNode;
}
export function FilterContractProvider({
  children,
}: FilterContractProviderProps) {
  return (
    <FilterContractContext.Provider value={useFilterContract()}>
      {children}
    </FilterContractContext.Provider>
  );
}